// extracted by mini-css-extract-plugin
export var container = "Double-module--container--MuNJt";
export var inner = "Double-module--inner--DwE1V";
export var col = "Double-module--col--jEL2V";
export var image = "Double-module--image--3+nC0";
export var text = "Double-module--text--hlp8G";
export var reverse = "Double-module--reverse--hwmqP";